import React from "react";

class DisabledShipmentsButton extends React.Component {
  render() {
    return (
      <a className="button button--disabled">Shipments</a>
    );
  }
}

export default DisabledShipmentsButton; 